import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Hidden from "@material-ui/core/Hidden";
import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ColoredStatus from "./ColoredStatus";
const DoubleLineSmDown = (props) => {
    const { secondLineKey, children, ...rest } = props;
    const theme = useTheme();
    const isMobile = !useMediaQuery(theme.breakpoints.up("sm"));
    return (_jsxs(Box, { display: isMobile ? "flex" : undefined, alignItems: "center", children: [_jsx(Hidden, { smUp: true, children: _jsx(ColoredStatus, { mr: 1, ...rest }) }), _jsxs("div", { children: [_jsx(Box, { fontWeight: "bold", children: children }), _jsx(Hidden, { mdUp: true, children: _jsx("div", { children: props.rowData[secondLineKey] }) })] })] }));
};
export default DoubleLineSmDown;
//# sourceMappingURL=DoubleLineSmDown.js.map